//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { go, replace } from "@/util/router";
import { mapState } from "vuex";
const AuditStatus = ["未审核", "已审核"];
//  import { _qAll, isNullOrEmpty } from '@/util/util'
import { getOrder } from "@/service/index";
import { zdsCategory } from "./../../config/env";
import ZSelect from "@/components/Select";
export default {
  data() {
    return {
      Items: [],
      pageNum: 0,
      pageCount: 0,
      pageSize: 10,
      isLock: false,
      zdsCategory: [
        { oid: "", name: "全部" },
        { oid: zdsCategory.ZSQ, name: "镶嵌类" },
        { oid: zdsCategory.ZSJ, name: "素金类" },
        { oid: zdsCategory.ZYHP, name: "易耗品" },
      ],
      // ZdsType: [{oid: -1, name: '全部'}, {oid: 0, name: '现货'}, {oid: 1, name: '委外'}],
      // -1 全部 0 展厅现货 1 在线现货 2 常规现货 3 委外下单 //2022.04.07 add 4 素金配货
      ZdsType: [
        { oid: -1, name: "全部" },
        { oid: 0, name: "展厅现货" },
        { oid: 1, name: "在线现货" },
        { oid: 2, name: "常规现货" },
        { oid: 3, name: "委外下单" },
        { oid: 4, name: "素金配货" },
      ],
      StartTime: new Date(new Date().setDate(1)).toLocaleDateString(),
      EndTime: new Date().toLocaleDateString(),
      pData: { pageSize: 10 },
      bind_P: "",
    };
  },
  components: {
    ZSelect,
  },
  created() {},
  mounted() {
    this.pagescroll();
  },
  watch: {
    $route: function (to, from) {
      // 跳转携带盘号
      let _P = localStorage.getItem("_P");
      console.log("===========", _P);
      if (_P) {
        this.bind_P = "?p=" + _P;
      }
    },
  },
  methods: {
    onResultChange(val) {
      let vm = this;
      if (val.target === "DL") {
        console.log(val);
        vm.pData.bigCode = val.idx;
      } else if (val.target === "TY") {
        console.log(val);
        vm.pData.orderType = val.idx;
      }
    },
    showList(idx) {
      let obj = this.Items[idx];
      obj.showList = !obj.showList;
    },
    show() {},
    getCategory(obj) {
      let ls = this.zdsCategory.filter((c) => c.oid === obj);
      return ls.length > 0 ? ls[0].name : obj;
    },
    searchData() {
      let vm = this;
      vm.pageNum = 0;
      vm.Items = [];
      this.getOrder();
    },
    getOrder() {
      let vm = this;
      vm.pData.pageNum = vm.pageNum;
      vm.pData.dateFrom = vm.StartTime;
      vm.pData.dateTo = vm.EndTime;
      vm.isLock = true;
      getOrder(vm.pData, (result) => {
        vm.isLock = false;
        if (result.code === "1") {
          let tag = JSON.parse(result.tag);
          vm.pageCount = tag.Dict.records;
          let ls = JSON.parse(result.data);
          console.log(ls);
          for (let item of ls) {
            item.showList = false;
            item.AuditStatus = AuditStatus[item.AuditStatus];
            vm.Items.push(item);
          }
        }
      });
    },
    doDetail(val, event, type) {
      console.log(event);
      if (event.target.nodeName.toLowerCase() === "button") {
        return;
      }
      if (type != undefined && (type == 0 || type == 1)) {
        go("/orderdetail/" + val, this.$router);
      }
    },
    pagescroll() {
      let self = this;
      window.onscroll = function () {
        let body = document.body;
        let scrollTop =
          body.scrollTop === 0
            ? document.documentElement.scrollTop
            : body.scrollTop;
        let dHeight = body.scrollHeight;
        let height = document.documentElement.clientHeight;
        if (scrollTop + height >= dHeight - 100) {
          if (self.pageCount - self.pageNum * self.pageSize > self.pageSize) {
            if (!self.isLock) {
              self.isLock = true;
              self.pageNum += 1;
              self.getOrder();
            }
          }
        }
      };
    },
    loginOut() {
      this.clearCookie();
      window.location.replace("/");
    },
    clearCookie() {
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (var i = keys.length; i--; )
          document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString();
      }
    },
  },
  computed: {
    ...mapState({
      route: (state) => state.route,
      path: (state) => state.route.path,
    }),
  },
};



// WEBPACK FOOTER //
// ./src/page/order/index.vue